module.exports = __webpack_public_path__ + "img/octa-app-store.dd4d5be0.png";